import React from 'react';
import Header from './Header';
import AdvantagesCarousel from './AdvantagesCarousel';
import PricingSection from './PricingSection';
import Footer from './Footer';
import { WhatsAppButton } from './WhatsAppButton';

const HomePage = () => {
  return (
    <div className="home-page">
      <Header />
      
      <main className="main-content">
        {/* Hero Section with Advantages Carousel - 70% */}
        <div className="hero-advantages-section">
          <AdvantagesCarousel />
        </div>
        
        {/* Spacer - 5% */}
        <div className="section-spacer"></div>
        
        {/* Pricing Section - 25% */}
        <div className="pricing-wrapper">
          <PricingSection />
        </div>
        <div style={{ textAlign: 'center', padding: '2.5rem 1rem 3rem', display: 'flex', flexWrap: 'wrap', gap: '1rem', justifyContent: 'center' }} data-testid="home-whatsapp-section">
          <a href="https://livrum.com.br/livrum-catalogo-demonstrativo" target="_blank" rel="noopener noreferrer" data-testid="home-demo-catalog-btn"
            style={{ display: 'inline-flex', alignItems: 'center', background: '#0d9488', color: 'white', borderRadius: 999, fontWeight: 700, textDecoration: 'none', padding: '0.85rem 1.6rem', boxShadow: '0 8px 20px rgba(13,148,136,0.3)' }}>
            Conheça o catálogo de demonstração
          </a>
          <WhatsAppButton testId="home-whatsapp-btn" />
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default HomePage;
